import './polyfills/from';

window.document.documentElement.classList.add('loading');
window.document.documentElement.classList.add('js');
window.document.documentElement.classList.remove('no-js');

window.addEventListener('load', () => {
  window.document.documentElement.classList.remove(
    'loading'
  );
});



// WEBPACK FOOTER //
// ../work/src/js/head.js